import { querySelectorOrThrow } from '../../utils/dom/querySelectorOrThrow';
import { IInitialisable } from '../../interfaces/IInitialisable';
import { CookieService } from './CookieService';
import { CookiePolicy } from './CookiePolicy';

export class CookieBanner implements IInitialisable {
	querySelectorOrThrow = querySelectorOrThrow;
	private cookieService: CookieService;
	private cookieBannerZone = '#js_cookie-banner-container';
	private cookieBanner = '.banner-window';
	private documentHelper = document;

	constructor(private cookieName: string, private cookieDomain: string, private htmlTemplate: string) {
		this.cookieName = cookieName;
		this.cookieDomain = cookieDomain;
		this.cookieService = new CookieService(cookieName, cookieDomain);
	}

	public Init(): void {
		const cookieBannerZone = this.documentHelper.querySelectorAll<HTMLElement>(this.cookieBannerZone);
		if (cookieBannerZone.length > 0) {
			this.setup();
		}
	}

	// Tested
	private setup(): void {
		const parentDiv = this.documentHelper.createElement('div');
		parentDiv.innerHTML = this.htmlTemplate;

		if (this.hasCookieBeenSet() === false) {
			const bannerWrapper = this.querySelectorOrThrow<HTMLElement>(this.documentHelper, this.cookieBannerZone);
			parentDiv.childNodes.forEach(x => bannerWrapper.appendChild(x));

			const editCookiesButton = this.querySelectorOrThrow(bannerWrapper, '.cc-decide');
			editCookiesButton.addEventListener('click', this.editCookiePreferences.bind(this));

			const dismissBannerButton = this.querySelectorOrThrow(bannerWrapper, '.cc-dismiss');
			dismissBannerButton.addEventListener('click', this.dismissBannerAndSetInitialCookie.bind(this));
		}
	}

	// Tested
	private hasCookieBeenSet(): boolean {
		return !!this.cookieService.getCurrentCookieValue();
	}

	// Tested
	private editCookiePreferences(): void {
		new CookiePolicy(this.cookieName, this.cookieDomain).Init();
		this.dismissBanner();
	}

	// Tested
	private dismissBanner(): void {
		const banner = this.documentHelper.querySelector(this.cookieBanner) as HTMLElement;
		if (banner !== null) {
			banner.style.display = 'none';
		}
	}

	// Tested
	private dismissBannerAndSetInitialCookie(): void {
		this.dismissBanner();
		this.cookieService.setInitialCookie();
	}
}
